<template>
    <div>
        <div class="row p-b-lg">
            <div class="col-md-9 --edit">
                <a :href="createUrl" class="btn --green-light --white-font">Create a Rate</a>
                <a @click="showHistory" class="btn --blue-light btn-primary" v-if="!showingHistory">Show History</a>
                <a @click="showRates" class="btn --blue-light btn-primary" v-if="showingHistory">Show Current Rates</a>
                <a :href="bulkUrl" class="btn --blue-light btn-primary">Bulk Edit</a>
            </div>
        </div>
        <div class="row p-b-lg">
            <div class="col-xs-3">
                <label>Filter by Type:</label>
                <select v-model="filterType" class="form-control" :disabled="loadingRates">
                    <option value="">--</option>
                    <option
                        v-for="(typeName, typeKey) in types"
                        v-bind:value="typeKey"
                        v-bind:key="typeKey"
                        >{{typeName}}</option>
                </select>
            </div>
            <div class="col-xs-3">
                <label>Market Group:</label>
                <select v-model="filterMarketGroup" class="form-control" :disabled="loadingRates">
                    <option value="">--</option>
                    <option
                        v-for="group in groups"
                        v-bind:value="group.id"
                        v-bind:key="group.id"
                        >{{group.name}}</option>
                </select>
            </div>
            <div class="col-xs-3">
                <br />
                <label v-if="loadingRates">Please wait while loading...</label>
                <a href="#" v-else v-on:click="editAll" class="btn btn-primary" v-show="!showingHistory">
                    <span class="glyphicon glyphicon-pencil"></span> Edit All
                </a>
            </div>
        </div>
        <table class="table table-striped rate-table">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Market Group</th>
                    <th>Exp Date</th>
                    <th>Intro<br />Rate</th>
                    <th>Intro<br />Term</th>
                    <th>Rate</th>
                    <th>Term</th>
                    <th>Loan Amount<br />Min</th>
                    <th>Loan Amount<br />Max</th>
                    <th>Fees</th>
                    <th>Draw<br />Amount</th>
                    <th>Fico<br />Min</th>
                    <th>Fico<br />Max</th>
                    <th>LTV<br />Min</th>
                    <th>LTV<br />Max</th>
                    <th v-if="featureFlag('home-equity.sponsored_rate')">Sponsored<br />Rate</th>
                    <th colspan="3" v-show="!showingHistory">Action</th>
                    <th v-show="showingHistory">Date Recorded</th>
                </tr>
            </thead>
            <template v-if="rates.length > 0">
                <rate-list-row
                    v-for="rate in filteredRates"
                    v-bind:rate="rate"
                    v-bind:editing="ratesEditMode[rate.id]"
                    v-bind:key="rate.id"
                    v-bind:showingHistory="showingHistory"
                ></rate-list-row>
                <tbody v-if="filteredRates.length == 0">
                    <tr>
                        <td colspan="17">No Rates match the given filter.  <a href="#" @click="clearFilter">Click here to clear the filter</a>.</td>
                    </tr>
                </tbody>
            </template>
            <tbody v-else>
                <tr>
                    <td colspan="17">No Rates have been created.  <a href="/campaigns/home-equity/rates/create">Click here to create one</a>.</td>
                </tr>
            </tbody>
        </table>
    </div>
    </template>
    
    <style lang="scss">
        .btn.--blue-light {
            border: solid 3px #337ab7;
        }
    </style>
    
    <script type="text/babel">
    import { mapActions, mapGetters } from 'vuex';
    import RateListRow from './rate-list-row.vue'
    import store from './store.js'
    
    export default {
        store: store,
        props: ['createUrl', 'bulkUrl'],
        data() {
            return {
                filterType: '',
                filterMarketGroup: '',
                showingHistory: false
            }
        },
        computed: {
            ...mapGetters([
                'rates',
                'types',
                'groups',
                'loadingRates',
                'ratesEditMode',
            ]),
            filteredRates() {
                let rates = this.rates;
                if (this.filterType) {
                    rates = rates.filter((i) => i.type == this.filterType)
                }
                if (this.filterMarketGroup) {
                    rates = rates.filter((i) => i.market_group_id == this.filterMarketGroup)
                }
                return rates;
            }
        },
        methods: {
            ...mapActions([
                'fetchRates',
                'fetchMarketGroups',
                'beginEditMode',
                'endEditMode',
                'beginEditModeAll',
            ]),
            clearFilter(e) {
                e.preventDefault();
                this.filterType = '';
                this.filterMarketGroup = '';
            },
            editAll(e) {
                e.preventDefault();
                this.beginEditModeAll();
            },
            showRates: function() {
                this.fetchRates();
                this.showingHistory = false;
            },
            showHistory: function() {
                this.showingHistory = true;
            }
        },
        mounted() {
            this.fetchRates();
            this.fetchMarketGroups();
        },
        components: {
            RateListRow
        }
    }
    </script>